export default __webpack_public_path__ + "static/media/logo.1f9fa6c6.jpeg";